import { Injectable, Inject, Optional, EventEmitter, Component, Injector, Input, Output, NgModule } from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { NotificationsService } from '@mt-ng2/notifications-module';
import { pluralize, markAllFormFieldsAsTouched } from '@mt-ng2/common-functions';
import { ClaimsService, ClaimValues } from '@mt-ng2/auth-module';
import { SearchParams } from '@mt-ng2/common-classes';
import { SortDirection, EntityListConfig, EntityListColumn, EntityListModule } from '@mt-ng2/entity-list-module';
import { EntityComponentsNotesModuleConfigToken } from '@mt-ng2/entity-components-notes-config';
import { FormControl, FormGroup } from '@angular/forms';
import { debounceTime } from 'rxjs/operators';
import { CommonModule } from '@angular/common';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { MtNoteControlModule } from '@mt-ng2/note-control';
import { DynamicFormModule } from '@mt-ng2/dynamic-form';
import { MtAlertsModule } from '@mt-ng2/alerts-module';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';
import * as ɵngcc2 from '@mt-ng2/note-control';
import * as ɵngcc3 from '@mt-ng2/alerts-module';
import * as ɵngcc4 from '@angular/forms';
import * as ɵngcc5 from '@mt-ng2/entity-list-module';
import * as ɵngcc6 from '@angular/router';

function CommonNotesComponent_div_1_ul_5_li_2_div_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "div", 14);
} if (rf & 2) {
    const note_r7 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵproperty("innerHTML", note_r7.NoteText, ɵngcc0.ɵɵsanitizeHtml);
} }
function CommonNotesComponent_div_1_ul_5_li_2_Template(rf, ctx) { if (rf & 1) {
    const _r11 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "li", 12);
    ɵngcc0.ɵɵlistener("click", function CommonNotesComponent_div_1_ul_5_li_2_Template_li_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r11); const note_r7 = ctx.$implicit; const ctx_r10 = ɵngcc0.ɵɵnextContext(3); return ctx_r10.selectNote(note_r7); });
    ɵngcc0.ɵɵtext(1, "\n                    ");
    ɵngcc0.ɵɵelementStart(2, "span");
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(4, "\n                    ");
    ɵngcc0.ɵɵtemplate(5, CommonNotesComponent_div_1_ul_5_li_2_div_5_Template, 1, 1, "div", 13);
    ɵngcc0.ɵɵtext(6, "\n                ");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const note_r7 = ctx.$implicit;
    const ctx_r6 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(note_r7.Title);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r6.selectedNote === note_r7);
} }
function CommonNotesComponent_div_1_ul_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "ul", 10);
    ɵngcc0.ɵɵtext(1, "\n                ");
    ɵngcc0.ɵɵtemplate(2, CommonNotesComponent_div_1_ul_5_li_2_Template, 7, 2, "li", 11);
    ɵngcc0.ɵɵtext(3, "\n            ");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r2._notes);
} }
function CommonNotesComponent_div_1_i_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "i");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1("No ", ctx_r3.getPluralObjectName(), "");
} }
function CommonNotesComponent_div_1_span_19_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate2("", ctx_r4._max, " of ", ctx_r4._total, "");
} }
function CommonNotesComponent_div_1_div_22_Template(rf, ctx) { if (rf & 1) {
    const _r13 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 15);
    ɵngcc0.ɵɵtext(1, "\n                ");
    ɵngcc0.ɵɵelementStart(2, "a", 16);
    ɵngcc0.ɵɵlistener("click", function CommonNotesComponent_div_1_div_22_Template_a_click_2_listener() { ɵngcc0.ɵɵrestoreView(_r13); const ctx_r12 = ɵngcc0.ɵɵnextContext(2); return ctx_r12.seeAll(); });
    ɵngcc0.ɵɵtext(3, "see all\n                    ");
    ɵngcc0.ɵɵelementStart(4, "span", 17);
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(6, "\n                ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(7, "\n            ");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵtextInterpolate(ctx_r5._total);
} }
function CommonNotesComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r15 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 2);
    ɵngcc0.ɵɵtext(1, "\n            ");
    ɵngcc0.ɵɵelementStart(2, "h4");
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(4, "\n\n            ");
    ɵngcc0.ɵɵtemplate(5, CommonNotesComponent_div_1_ul_5_Template, 4, 1, "ul", 3);
    ɵngcc0.ɵɵtext(6, "\n            ");
    ɵngcc0.ɵɵtemplate(7, CommonNotesComponent_div_1_i_7_Template, 2, 1, "i", 4);
    ɵngcc0.ɵɵtext(8, "\n            ");
    ɵngcc0.ɵɵelementStart(9, "div", 5);
    ɵngcc0.ɵɵtext(10, "\n                ");
    ɵngcc0.ɵɵelementStart(11, "button", 6);
    ɵngcc0.ɵɵlistener("click", function CommonNotesComponent_div_1_Template_button_click_11_listener() { ɵngcc0.ɵɵrestoreView(_r15); const ctx_r14 = ɵngcc0.ɵɵnextContext(); return ctx_r14.addNote(); });
    ɵngcc0.ɵɵtext(12, "\n                    ");
    ɵngcc0.ɵɵelement(13, "span", 7);
    ɵngcc0.ɵɵtext(14, "\n                ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(15, "\n            ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(16, "\n            ");
    ɵngcc0.ɵɵelementStart(17, "div", 8);
    ɵngcc0.ɵɵtext(18, "\n                ");
    ɵngcc0.ɵɵtemplate(19, CommonNotesComponent_div_1_span_19_Template, 2, 2, "span", 4);
    ɵngcc0.ɵɵtext(20, "\n            ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(21, "\n            ");
    ɵngcc0.ɵɵtemplate(22, CommonNotesComponent_div_1_div_22_Template, 8, 1, "div", 9);
    ɵngcc0.ɵɵtext(23, "\n        ");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0._componentName);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0._notes.length);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r0._notes.length);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("hidden", !ctx_r0._canAdd);
    ɵngcc0.ɵɵadvance(10);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.showTotal());
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.showTotal());
} }
function CommonNotesComponent_div_3_button_15_Template(rf, ctx) { if (rf & 1) {
    const _r18 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 23);
    ɵngcc0.ɵɵlistener("mtConfirm", function CommonNotesComponent_div_3_button_15_Template_button_mtConfirm_0_listener() { ɵngcc0.ɵɵrestoreView(_r18); const ctx_r17 = ɵngcc0.ɵɵnextContext(2); return ctx_r17.delete(); });
    ɵngcc0.ɵɵtext(1, "Delete");
    ɵngcc0.ɵɵelementEnd();
} }
function CommonNotesComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r20 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 18);
    ɵngcc0.ɵɵtext(1, "\n            ");
    ɵngcc0.ɵɵelementStart(2, "h4");
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(4, "\n            ");
    ɵngcc0.ɵɵelementStart(5, "div");
    ɵngcc0.ɵɵtext(6, "\n                ");
    ɵngcc0.ɵɵelementStart(7, "mt-note", 19);
    ɵngcc0.ɵɵlistener("ready", function CommonNotesComponent_div_3_Template_mt_note_ready_7_listener($event) { ɵngcc0.ɵɵrestoreView(_r20); const ctx_r19 = ɵngcc0.ɵɵnextContext(); return ctx_r19.noteForm = $event.form; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(8, "\n                ");
    ɵngcc0.ɵɵelementStart(9, "button", 20);
    ɵngcc0.ɵɵlistener("click", function CommonNotesComponent_div_3_Template_button_click_9_listener() { ɵngcc0.ɵɵrestoreView(_r20); const ctx_r21 = ɵngcc0.ɵɵnextContext(); return ctx_r21.save(); });
    ɵngcc0.ɵɵtext(10, "Save");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(11, "\n                ");
    ɵngcc0.ɵɵelementStart(12, "button", 21);
    ɵngcc0.ɵɵlistener("click", function CommonNotesComponent_div_3_Template_button_click_12_listener() { ɵngcc0.ɵɵrestoreView(_r20); const ctx_r22 = ɵngcc0.ɵɵnextContext(); return ctx_r22.cancel(); });
    ɵngcc0.ɵɵtext(13, "Cancel");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(14, "\n                ");
    ɵngcc0.ɵɵtemplate(15, CommonNotesComponent_div_3_button_15_Template, 2, 0, "button", 22);
    ɵngcc0.ɵɵtext(16, "\n            ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(17, "\n        ");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate2("", ctx_r1.selectedNote.Id > 0 ? "Edit" : "Add", " ", ctx_r1._objectName, "");
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("note", ctx_r1.selectedNote)("focus", true);
    ɵngcc0.ɵɵadvance(8);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.selectedNote.Id > 0);
} }
function CommonNotesListComponent_div_1_div_30_Template(rf, ctx) { if (rf & 1) {
    const _r4 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 11);
    ɵngcc0.ɵɵlistener("click", function CommonNotesListComponent_div_1_div_30_Template_div_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r3 = ɵngcc0.ɵɵnextContext(2); return ctx_r3.addNote(); });
    ɵngcc0.ɵɵtext(1, "\n                ");
    ɵngcc0.ɵɵelementStart(2, "a", 12);
    ɵngcc0.ɵɵtext(3, "\n                    ");
    ɵngcc0.ɵɵelement(4, "span", 13);
    ɵngcc0.ɵɵtext(5, "\n                ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(6, "\n            ");
    ɵngcc0.ɵɵelementEnd();
} }
const _c0 = function () { return ["../"]; };
function CommonNotesListComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r6 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtext(1, "\n            ");
    ɵngcc0.ɵɵelementStart(2, "div");
    ɵngcc0.ɵɵtext(3, "\n                ");
    ɵngcc0.ɵɵelementStart(4, "div", 2);
    ɵngcc0.ɵɵtext(5, "\n                    ");
    ɵngcc0.ɵɵelement(6, "input", 3);
    ɵngcc0.ɵɵtext(7, "\n                    ");
    ɵngcc0.ɵɵelementStart(8, "span", 4);
    ɵngcc0.ɵɵtext(9, "\n                        ");
    ɵngcc0.ɵɵelementStart(10, "button", 5);
    ɵngcc0.ɵɵlistener("click", function CommonNotesListComponent_div_1_Template_button_click_10_listener() { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r5 = ɵngcc0.ɵɵnextContext(); return ctx_r5.clearSearch(); });
    ɵngcc0.ɵɵtext(11, "\n                            ");
    ɵngcc0.ɵɵelement(12, "i", 6);
    ɵngcc0.ɵɵtext(13, "\n                            ");
    ɵngcc0.ɵɵelement(14, "i", 7);
    ɵngcc0.ɵɵtext(15, "\n                            ");
    ɵngcc0.ɵɵelement(16, "i", 6);
    ɵngcc0.ɵɵtext(17, "\n                        ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(18, "\n                    ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(19, "\n                ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(20, "\n                ");
    ɵngcc0.ɵɵelement(21, "br");
    ɵngcc0.ɵɵtext(22, "\n            ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(23, "\n            ");
    ɵngcc0.ɵɵelementStart(24, "entity-list", 8);
    ɵngcc0.ɵɵlistener("currentPageChange", function CommonNotesListComponent_div_1_Template_entity_list_currentPageChange_24_listener($event) { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r7 = ɵngcc0.ɵɵnextContext(); return ctx_r7.currentPage = $event; })("onPageChanged", function CommonNotesListComponent_div_1_Template_entity_list_onPageChanged_24_listener() { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r8 = ɵngcc0.ɵɵnextContext(); return ctx_r8.getNotes(); })("onItemSelected", function CommonNotesListComponent_div_1_Template_entity_list_onItemSelected_24_listener($event) { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r9 = ɵngcc0.ɵɵnextContext(); return ctx_r9.selectNote($event); })("onItemDeleted", function CommonNotesListComponent_div_1_Template_entity_list_onItemDeleted_24_listener($event) { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r10 = ɵngcc0.ɵɵnextContext(); return ctx_r10.deleteNote($event); })("onColumnSorted", function CommonNotesListComponent_div_1_Template_entity_list_onColumnSorted_24_listener($event) { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r11 = ɵngcc0.ɵɵnextContext(); return ctx_r11.columnSorted($event); });
    ɵngcc0.ɵɵtext(25, "\n            ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(26, "\n            ");
    ɵngcc0.ɵɵelementStart(27, "a", 9);
    ɵngcc0.ɵɵtext(28, "Back");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(29, "\n            ");
    ɵngcc0.ɵɵtemplate(30, CommonNotesListComponent_div_1_div_30_Template, 7, 0, "div", 10);
    ɵngcc0.ɵɵtext(31, "\n        ");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(6);
    ɵngcc0.ɵɵproperty("formControl", ctx_r0.searchControl);
    ɵngcc0.ɵɵadvance(18);
    ɵngcc0.ɵɵproperty("entities", ctx_r0.notes)("itemsPerPage", ctx_r0.itemsPerPage)("total", ctx_r0.total)("currentPage", ctx_r0.currentPage)("entityListConfig", ctx_r0.entityListConfig);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("routerLink", ɵngcc0.ɵɵpureFunction0(8, _c0));
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.canEdit);
} }
function CommonNotesListComponent_div_3_button_15_Template(rf, ctx) { if (rf & 1) {
    const _r14 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 20);
    ɵngcc0.ɵɵlistener("mtConfirm", function CommonNotesListComponent_div_3_button_15_Template_button_mtConfirm_0_listener() { ɵngcc0.ɵɵrestoreView(_r14); const ctx_r13 = ɵngcc0.ɵɵnextContext(2); return ctx_r13.delete(); });
    ɵngcc0.ɵɵtext(1, "Delete");
    ɵngcc0.ɵɵelementEnd();
} }
function CommonNotesListComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r16 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 14);
    ɵngcc0.ɵɵtext(1, "\n            ");
    ɵngcc0.ɵɵelementStart(2, "h4");
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(4, "\n            ");
    ɵngcc0.ɵɵelementStart(5, "form", 15);
    ɵngcc0.ɵɵlistener("ngSubmit", function CommonNotesListComponent_div_3_Template_form_ngSubmit_5_listener() { ɵngcc0.ɵɵrestoreView(_r16); const ctx_r15 = ɵngcc0.ɵɵnextContext(); return ctx_r15.save(); });
    ɵngcc0.ɵɵtext(6, "\n                ");
    ɵngcc0.ɵɵelement(7, "mt-note", 16);
    ɵngcc0.ɵɵtext(8, "\n                ");
    ɵngcc0.ɵɵelementStart(9, "button", 17);
    ɵngcc0.ɵɵtext(10, "Save");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(11, "\n                ");
    ɵngcc0.ɵɵelementStart(12, "button", 18);
    ɵngcc0.ɵɵlistener("click", function CommonNotesListComponent_div_3_Template_button_click_12_listener() { ɵngcc0.ɵɵrestoreView(_r16); const ctx_r17 = ɵngcc0.ɵɵnextContext(); return ctx_r17.cancel(); });
    ɵngcc0.ɵɵtext(13, "Cancel");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(14, "\n                ");
    ɵngcc0.ɵɵtemplate(15, CommonNotesListComponent_div_3_button_15_Template, 2, 0, "button", 19);
    ɵngcc0.ɵɵtext(16, "\n            ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(17, "\n        ");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate2("", ctx_r1.selectedNote.Id > 0 ? "Edit" : "Add", " ", ctx_r1.objectName, "");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("formGroup", ctx_r1.noteForm);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("note", ctx_r1.selectedNote)("parentForm", ctx_r1.noteForm)("focus", true);
    ɵngcc0.ɵɵadvance(8);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.selectedNote.Id > 0);
} }
const defaultModuleConfig = {
    disableSort: false,
    max: 3,
};
class EntityComponentsNotesModuleConfig {
    constructor(config) {
        Object.assign(this, defaultModuleConfig, config);
    }
}
EntityComponentsNotesModuleConfig.ɵfac = function EntityComponentsNotesModuleConfig_Factory(t) { return new (t || EntityComponentsNotesModuleConfig)(ɵngcc0.ɵɵinject(EntityComponentsNotesModuleConfigToken, 8)); };
EntityComponentsNotesModuleConfig.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: EntityComponentsNotesModuleConfig, factory: EntityComponentsNotesModuleConfig.ɵfac });
EntityComponentsNotesModuleConfig.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [EntityComponentsNotesModuleConfigToken,] }, { type: Optional }] }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(EntityComponentsNotesModuleConfig, [{
        type: Injectable
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [EntityComponentsNotesModuleConfigToken]
            }, {
                type: Optional
            }] }]; }, null); })();

class CommonNotesComponent {
    constructor(injector) {
        this.injector = injector;
        this._notes = [];
        this.notesPassedIn = false;
        this.onSave = new EventEmitter();
        this.onDelete = new EventEmitter();
        this._selectedNote = null;
        this.newNote = {
            Id: 0,
            NoteText: '',
            Title: '',
        };
        this.route = injector.get(ActivatedRoute);
        this.router = injector.get(Router);
        this.notificationsService = injector.get(NotificationsService);
        this.claimsService = injector.get(ClaimsService);
        this.config = injector.get(EntityComponentsNotesModuleConfig);
        this._max = this.config.max;
    }
    set NoteArray(value) {
        this.notesPassedIn = true;
        this._notes = value;
        this.selectedNote = null;
        // NEED THIS for closing control
    }
    set total(value) {
        this._total = value;
    }
    set canAdd(value) {
        this._canAdd = value;
    }
    set canEdit(value) {
        this._canEdit = value;
    }
    set seeAllUrl(value) {
        this._seeAllUrl = value;
    }
    set objectName(value) {
        this._objectName = value;
    }
    set componentName(value) {
        this._componentName = value;
    }
    set max(value) {
        this._max = value;
    }
    get selectedNote() {
        return this._selectedNote;
    }
    set selectedNote(value) {
        if (value === null) {
            this.noteForm = null;
        }
        this._selectedNote = value;
    }
    get isEditing() {
        return this.selectedNote && this._canEdit;
    }
    ngOnInit() {
        this.setVariables();
        this.getNotes();
    }
    /**
     * Assigns local variables to defaults or config properties.
     */
    setVariables() {
        var _a, _b, _c;
        const config = this.route.parent.snapshot.data;
        if (config === null || config === void 0 ? void 0 : config.entityIdParam) {
            this.parentId = +this.route.parent.snapshot.paramMap.get(config.entityIdParam);
        }
        const service = this.service || (config === null || config === void 0 ? void 0 : config.service) || null;
        if (service) {
            if (typeof service === 'function') {
                this.service = this.injector.get(service);
            }
        }
        if (this._canEdit === undefined) {
            this._canEdit = (config === null || config === void 0 ? void 0 : config.claimType) ? this.claimsService.hasClaim(config.claimType, [ClaimValues.FullAccess]) : false;
        }
        if (this._canAdd === undefined) {
            this._canAdd = this._canEdit;
        }
        if (this._seeAllUrl === undefined) {
            this._seeAllUrl = (_a = config === null || config === void 0 ? void 0 : config.notesPath) !== null && _a !== void 0 ? _a : 'notes';
        }
        if (this._objectName === undefined) {
            this._objectName = (_b = config === null || config === void 0 ? void 0 : config.notesObjectName) !== null && _b !== void 0 ? _b : 'Note';
        }
        if (this._componentName === undefined) {
            this._componentName = (_c = config === null || config === void 0 ? void 0 : config.notesComponentName) !== null && _c !== void 0 ? _c : 'Notes';
        }
    }
    getNotes() {
        if (!this.notesPassedIn && this.hasService()) {
            const searchparamProperties = {
                order: 'Title',
                orderDirection: SortDirection.Asc,
                query: '',
                take: this._max,
            };
            const searchparams = new SearchParams(searchparamProperties);
            this.service.getNotes(this.parentId, searchparams).subscribe((response) => {
                this._notes = response.body;
                this._total = +response.headers.get('X-List-Count');
            });
        }
    }
    getPluralObjectName() {
        return pluralize(this._objectName);
    }
    showTotal() {
        return this._total && this._total > this._max;
    }
    hasService() {
        return this.service && this.parentId && this.parentId > 0;
    }
    seeAll() {
        this.router.navigate([`${this._seeAllUrl}`], {
            relativeTo: this.route,
        });
    }
    addNote() {
        if (!this._canAdd) {
            return;
        }
        this.selectedNote = Object.assign({}, this.newNote);
    }
    save() {
        if (this.notesPassedIn) {
            this.onSave.emit(this.noteForm.value);
        }
        else {
            this.saveNote(this.noteForm);
        }
    }
    saveNote(noteForm) {
        if (noteForm.valid) {
            const note = noteForm.value;
            this.service.saveNote(this.parentId, note).subscribe((success) => {
                this.notificationsService.success('Note Saved Successfully');
                if (this.selectedNote.Id === 0) {
                    this.selectedNote.Id = success;
                }
                this.onSave.emit(this.selectedNote);
                this.selectedNote = null;
                this.getNotes();
            }, (error) => this.notificationsService.error('Save Failed'));
        }
        else {
            this.notificationsService.error('Save Failed');
            markAllFormFieldsAsTouched(noteForm);
        }
    }
    cancel() {
        this.selectedNote = null;
    }
    delete() {
        if (this.notesPassedIn) {
            this.onDelete.emit(this.noteForm.value);
        }
        else {
            this.deleteNote(this.noteForm);
        }
    }
    deleteNote(noteForm) {
        this.service.deleteNote(this.parentId, noteForm.value.Id).subscribe((success) => {
            this.notificationsService.success('Note Deleted');
            this.onDelete.emit(this.selectedNote);
            this.selectedNote = null;
            this.getNotes();
        }, (error) => this.notificationsService.error('Delete Failed'));
    }
    selectNote(note) {
        if (this.selectedNote === note) {
            this.selectedNote = null;
        }
        else {
            this.selectedNote = note;
        }
    }
}
CommonNotesComponent.ɵfac = function CommonNotesComponent_Factory(t) { return new (t || CommonNotesComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Injector)); };
CommonNotesComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: CommonNotesComponent, selectors: [["app-common-notes"]], inputs: { NoteArray: "NoteArray", total: "total", canAdd: "canAdd", canEdit: "canEdit", seeAllUrl: "seeAllUrl", objectName: "objectName", componentName: "componentName", max: "max", service: "service" }, outputs: { onSave: "onSave", onDelete: "onDelete" }, decls: 5, vars: 2, consts: [["class", "miles-card padded", 4, "ngIf"], ["class", "miles-form padded", 4, "ngIf"], [1, "miles-card", "padded"], ["class", "list-group", 4, "ngIf"], [4, "ngIf"], [1, "fab-wrap", 3, "hidden"], ["type", "button", 1, "btn", "btn-primary", "btn-fab-md", "btn-fab-center", 3, "click"], [1, "fa", "fa-plus"], [1, "pull-right", "max-of-total"], ["class", "show-on-hover", 4, "ngIf"], [1, "list-group"], ["class", "list-group-item", 3, "click", 4, "ngFor", "ngForOf"], [1, "list-group-item", 3, "click"], [3, "innerHTML", 4, "ngIf"], [3, "innerHTML"], [1, "show-on-hover"], [1, "btn", "btn-primary", "btn-flat", "see-all", 3, "click"], [1, "badge"], [1, "miles-form", "padded"], [3, "note", "focus", "ready"], ["type", "submit", 1, "btn", "btn-flat", "btn-success", 3, "click"], ["type", "button", 1, "btn", "btn-flat", "btn-default", 3, "click"], ["type", "button", "class", "btn btn-flat btn-danger pull-right", 3, "mtConfirm", 4, "ngIf"], ["type", "button", 1, "btn", "btn-flat", "btn-danger", "pull-right", 3, "mtConfirm"]], template: function CommonNotesComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtext(0, "\n        ");
        ɵngcc0.ɵɵtemplate(1, CommonNotesComponent_div_1_Template, 24, 6, "div", 0);
        ɵngcc0.ɵɵtext(2, "\n        ");
        ɵngcc0.ɵɵtemplate(3, CommonNotesComponent_div_3_Template, 18, 5, "div", 1);
        ɵngcc0.ɵɵtext(4, "\n    ");
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.isEditing);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.isEditing);
    } }, directives: [ɵngcc1.NgIf, ɵngcc1.NgForOf, ɵngcc2.MtNoteComponent, ɵngcc3.MtConfirmDirective], encapsulation: 2 });
CommonNotesComponent.ctorParameters = () => [
    { type: Injector }
];
CommonNotesComponent.propDecorators = {
    NoteArray: [{ type: Input, args: ['NoteArray',] }],
    service: [{ type: Input, args: ['service',] }],
    total: [{ type: Input, args: ['total',] }],
    canAdd: [{ type: Input, args: ['canAdd',] }],
    canEdit: [{ type: Input, args: ['canEdit',] }],
    seeAllUrl: [{ type: Input, args: ['seeAllUrl',] }],
    objectName: [{ type: Input, args: ['objectName',] }],
    componentName: [{ type: Input, args: ['componentName',] }],
    max: [{ type: Input, args: ['max',] }],
    onSave: [{ type: Output, args: ['onSave',] }],
    onDelete: [{ type: Output, args: ['onDelete',] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(CommonNotesComponent, [{
        type: Component,
        args: [{
                selector: 'app-common-notes',
                template: `
        <div class="miles-card padded" *ngIf="!isEditing">
            <h4>{{ _componentName }}</h4>

            <ul *ngIf="_notes.length" class="list-group">
                <li *ngFor="let note of _notes" (click)="selectNote(note)" class="list-group-item">
                    <span>{{ note.Title }}</span>
                    <div *ngIf="selectedNote === note" [innerHTML]="note.NoteText"></div>
                </li>
            </ul>
            <i *ngIf="!_notes.length">No {{ getPluralObjectName() }}</i>
            <div [hidden]="!_canAdd" class="fab-wrap">
                <button type="button" class="btn btn-primary btn-fab-md btn-fab-center" (click)="addNote()">
                    <span class="fa fa-plus"></span>
                </button>
            </div>
            <div class="pull-right max-of-total">
                <span *ngIf="showTotal()">{{ _max }} of {{ _total }}</span>
            </div>
            <div class="show-on-hover" *ngIf="showTotal()">
                <a (click)="seeAll()" class="btn btn-primary btn-flat see-all"
                    >see all
                    <span class="badge">{{ _total }}</span>
                </a>
            </div>
        </div>
        <div class="miles-form padded" *ngIf="isEditing">
            <h4>{{ selectedNote.Id > 0 ? 'Edit' : 'Add' }} {{ _objectName }}</h4>
            <div>
                <mt-note [note]="selectedNote" [focus]="true" (ready)="noteForm = $event.form"></mt-note>
                <button type="submit" class="btn btn-flat btn-success" (click)="save()">Save</button>
                <button type="button" class="btn btn-flat btn-default" (click)="cancel()">Cancel</button>
                <button *ngIf="selectedNote.Id > 0" type="button" class="btn btn-flat btn-danger pull-right" (mtConfirm)="delete()">Delete</button>
            </div>
        </div>
    `
            }]
    }], function () { return [{ type: ɵngcc0.Injector }]; }, { onSave: [{
            type: Output,
            args: ['onSave']
        }], onDelete: [{
            type: Output,
            args: ['onDelete']
        }], NoteArray: [{
            type: Input,
            args: ['NoteArray']
        }], total: [{
            type: Input,
            args: ['total']
        }], canAdd: [{
            type: Input,
            args: ['canAdd']
        }], canEdit: [{
            type: Input,
            args: ['canEdit']
        }], seeAllUrl: [{
            type: Input,
            args: ['seeAllUrl']
        }], objectName: [{
            type: Input,
            args: ['objectName']
        }], componentName: [{
            type: Input,
            args: ['componentName']
        }], max: [{
            type: Input,
            args: ['max']
        }], service: [{
            type: Input,
            args: ['service']
        }] }); })();

class NotesEntityListConfig extends EntityListConfig {
    constructor(disableSort) {
        const listConfig = {
            columns: [
                new EntityListColumn({
                    name: 'Title',
                    sort: {
                        disableSort: disableSort,
                    },
                }),
                new EntityListColumn({
                    accessors: ['NoteText'],
                    bindToInnerHtml: true,
                    name: 'Content',
                    sort: {
                        disableSort: disableSort,
                    },
                }),
            ],
            delete: {
                confirm: true,
                width: 50,
            },
        };
        super(listConfig);
    }
}

class CommonNotesListComponent {
    constructor(injector) {
        this.injector = injector;
        this.searchControl = new FormControl();
        this.itemsPerPage = 12;
        this.currentPage = 1;
        this.canEdit = false;
        this.objectName = 'Note';
        this._selectedNote = null;
        this.newNote = {
            Id: 0,
            NoteText: '',
            Title: '',
        };
        this.route = injector.get(ActivatedRoute);
        this.notificationsService = injector.get(NotificationsService);
        this.claimsService = injector.get(ClaimsService);
        this.config = injector.get(EntityComponentsNotesModuleConfig);
        this._disableSort = this.config.disableSort;
        this.entityListConfig = new NotesEntityListConfig(this._disableSort);
        this.order = this.entityListConfig.getDefaultSortProperty();
        this.orderDirection = this.entityListConfig.getDefaultSortDirection();
    }
    set disableSort(value) {
        this._disableSort = value;
    }
    get selectedNote() {
        return this._selectedNote;
    }
    set selectedNote(value) {
        if (value === null) {
            this.noteForm = new FormGroup({});
        }
        this._selectedNote = value;
    }
    ngOnInit() {
        this.searchControl.valueChanges.pipe(debounceTime(300)).subscribe((value) => this.getNotes());
        this.noteForm = new FormGroup({});
        const config = this.route.parent.snapshot.data;
        this.id = +this.route.parent.snapshot.paramMap.get(config.entityIdParam);
        this.canEdit = this.claimsService.hasClaim(config.claimType, [ClaimValues.FullAccess]);
        const service = this.getServiceFromConfig(config);
        this.service = this.injector.get(service);
        this.objectName = config.notesObjectName || 'Note';
        this.getNotes();
    }
    getServiceFromConfig(config) {
        var _a;
        let childRoute = this.route.snapshot;
        while (childRoute.firstChild) {
            childRoute = childRoute.firstChild;
        }
        const childConfig = childRoute.data;
        return (_a = childConfig === null || childConfig === void 0 ? void 0 : childConfig.service) !== null && _a !== void 0 ? _a : config === null || config === void 0 ? void 0 : config.service;
    }
    getNotes() {
        const search = this.searchControl.value;
        const searchparamProperties = {
            order: this.order,
            orderDirection: this.orderDirection,
            query: (search === null || search === void 0 ? void 0 : search.length) > 0 ? search : '',
            skip: (this.currentPage - 1) * this.itemsPerPage,
            take: this.itemsPerPage,
        };
        const searchparams = new SearchParams(searchparamProperties);
        this.service.getNotes(this.id, searchparams).subscribe((response) => {
            this.notes = response.body;
            this.total = +response.headers.get('X-List-Count');
        });
    }
    columnSorted(event) {
        this.order = event.column.sort.sortProperty;
        this.orderDirection = event.column.sort.direction === SortDirection.Desc ? 'desc' : 'asc';
        this.getNotes();
    }
    clearSearch() {
        this.searchControl.setValue('');
    }
    noNotes() {
        return !this.notes || this.notes.length === 0;
    }
    pagingNeeded() {
        return this.total > this.itemsPerPage;
    }
    addNote() {
        this.selectedNote = Object.assign({}, this.newNote);
    }
    save() {
        if (this.noteForm.valid) {
            const note = this.noteForm.value;
            this.service.saveNote(this.id, note).subscribe((success) => {
                this.notificationsService.success('Note Saved Successfully');
                this.selectedNote = null;
                this.getNotes();
            }, (error) => this.notificationsService.error('Save Failed'));
        }
        else {
            this.notificationsService.error('Save Failed');
            markAllFormFieldsAsTouched(this.noteForm);
        }
    }
    cancel() {
        this.selectedNote = null;
    }
    delete() {
        if (this.noteForm.value.Id) {
            this.deleteNoteById(this.noteForm.value.Id);
        }
    }
    deleteNote(event) {
        this.deleteNoteById(event.entity.Id);
    }
    deleteNoteById(noteId) {
        this.service.deleteNote(this.id, noteId).subscribe((success) => {
            this.notificationsService.success('Note Deleted');
            this.selectedNote = null;
            this.getNotes();
        }, (error) => this.notificationsService.error('Delete Failed'));
    }
    selectNote(event) {
        let note = event.entity;
        if (this.selectedNote === note) {
            this.selectedNote = null;
        }
        else {
            this.selectedNote = note;
        }
    }
}
CommonNotesListComponent.ɵfac = function CommonNotesListComponent_Factory(t) { return new (t || CommonNotesListComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Injector)); };
CommonNotesListComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: CommonNotesListComponent, selectors: [["app-common-notes-list"]], inputs: { disableSort: "disableSort" }, decls: 5, vars: 2, consts: [[4, "ngIf"], ["class", "miles-form padded", 4, "ngIf"], [1, "input-group"], ["type", "text", "placeholder", "Search", 1, "form-control", 3, "formControl"], [1, "input-group-btn"], ["type", "button", 1, "btn", "btn-default", "btn-nohover", "btn-flat", 3, "click"], [1, "fa"], ["aria-hidden", "true", 1, "fa", "fa-remove"], [3, "entities", "itemsPerPage", "total", "currentPage", "entityListConfig", "currentPageChange", "onPageChanged", "onItemSelected", "onItemDeleted", "onColumnSorted"], [1, "btn", "btn-default", 3, "routerLink"], ["class", "fab-wrap-b-r", 3, "click", 4, "ngIf"], [1, "fab-wrap-b-r", 3, "click"], [1, "btn", "btn-primary", "btn-fab-lg"], [1, "fa", "fa-plus"], [1, "miles-form", "padded"], [3, "formGroup", "ngSubmit"], [3, "note", "parentForm", "focus"], ["type", "submit", 1, "btn", "btn-flat", "btn-success"], ["type", "button", 1, "btn", "btn-flat", "btn-default", 3, "click"], ["type", "button", "class", "btn btn-flat btn-danger pull-right", 3, "mtConfirm", 4, "ngIf"], ["type", "button", 1, "btn", "btn-flat", "btn-danger", "pull-right", 3, "mtConfirm"]], template: function CommonNotesListComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtext(0, "\n        ");
        ɵngcc0.ɵɵtemplate(1, CommonNotesListComponent_div_1_Template, 32, 9, "div", 0);
        ɵngcc0.ɵɵtext(2, "\n        ");
        ɵngcc0.ɵɵtemplate(3, CommonNotesListComponent_div_3_Template, 18, 7, "div", 1);
        ɵngcc0.ɵɵtext(4, "\n    ");
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.selectedNote || !ctx.canEdit);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.selectedNote && ctx.canEdit);
    } }, directives: [ɵngcc1.NgIf, ɵngcc4.DefaultValueAccessor, ɵngcc4.NgControlStatus, ɵngcc4.FormControlDirective, ɵngcc5.EntityListComponent, ɵngcc6.RouterLinkWithHref, ɵngcc4.ɵangular_packages_forms_forms_y, ɵngcc4.NgControlStatusGroup, ɵngcc4.FormGroupDirective, ɵngcc2.MtNoteComponent, ɵngcc3.MtConfirmDirective], encapsulation: 2 });
CommonNotesListComponent.ctorParameters = () => [
    { type: Injector }
];
CommonNotesListComponent.propDecorators = {
    disableSort: [{ type: Input, args: ['disableSort',] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(CommonNotesListComponent, [{
        type: Component,
        args: [{
                selector: 'app-common-notes-list',
                template: `
        <div *ngIf="!selectedNote || !canEdit">
            <div>
                <div class="input-group">
                    <input type="text" [formControl]="searchControl" class="form-control" placeholder="Search" />
                    <span class="input-group-btn">
                        <button type="button" (click)="clearSearch()" class="btn btn-default btn-nohover btn-flat">
                            <i class="fa"></i>
                            <i class="fa fa-remove" aria-hidden="true"></i>
                            <i class="fa"></i>
                        </button>
                    </span>
                </div>
                <br />
            </div>
            <entity-list
                [entities]="notes"
                [itemsPerPage]="itemsPerPage"
                [total]="total"
                [(currentPage)]="currentPage"
                (onPageChanged)="getNotes()"
                (onItemSelected)="selectNote($event)"
                (onItemDeleted)="deleteNote($event)"
                (onColumnSorted)="columnSorted($event)"
                [entityListConfig]="entityListConfig"
            >
            </entity-list>
            <a [routerLink]="['../']" class="btn btn-default">Back</a>
            <div *ngIf="canEdit" class="fab-wrap-b-r" (click)="addNote()">
                <a class="btn btn-primary btn-fab-lg">
                    <span class="fa fa-plus"></span>
                </a>
            </div>
        </div>
        <div *ngIf="selectedNote && canEdit" class="miles-form padded">
            <h4>{{ selectedNote.Id > 0 ? 'Edit' : 'Add' }} {{ objectName }}</h4>
            <form [formGroup]="noteForm" (ngSubmit)="save()">
                <mt-note [note]="selectedNote" [parentForm]="noteForm" [focus]="true"></mt-note>
                <button type="submit" class="btn btn-flat btn-success">Save</button>
                <button type="button" class="btn btn-flat btn-default" (click)="cancel()">Cancel</button>
                <button *ngIf="selectedNote.Id > 0" type="button" class="btn btn-flat btn-danger pull-right" (mtConfirm)="delete()">Delete</button>
            </form>
        </div>
    `
            }]
    }], function () { return [{ type: ɵngcc0.Injector }]; }, { disableSort: [{
            type: Input,
            args: ['disableSort']
        }] }); })();

class EntityComponentsNotesModule {
}
EntityComponentsNotesModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: EntityComponentsNotesModule });
EntityComponentsNotesModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function EntityComponentsNotesModule_Factory(t) { return new (t || EntityComponentsNotesModule)(); }, providers: [EntityComponentsNotesModuleConfig], imports: [[CommonModule, NgbModule, RouterModule, DynamicFormModule, MtNoteControlModule, EntityListModule, MtAlertsModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(EntityComponentsNotesModule, { declarations: function () { return [CommonNotesComponent, CommonNotesListComponent]; }, imports: function () { return [CommonModule, NgbModule, RouterModule, DynamicFormModule, MtNoteControlModule, EntityListModule, MtAlertsModule]; }, exports: function () { return [CommonNotesComponent, CommonNotesListComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(EntityComponentsNotesModule, [{
        type: NgModule,
        args: [{
                declarations: [CommonNotesComponent, CommonNotesListComponent],
                exports: [CommonNotesComponent, CommonNotesListComponent],
                imports: [CommonModule, NgbModule, RouterModule, DynamicFormModule, MtNoteControlModule, EntityListModule, MtAlertsModule],
                providers: [EntityComponentsNotesModuleConfig]
            }]
    }], null, null); })();

/**
 * Generated bundle index. Do not edit.
 */

export { CommonNotesComponent, CommonNotesListComponent, EntityComponentsNotesModule, EntityComponentsNotesModuleConfig as ɵa };

//# sourceMappingURL=mt-ng2-entity-components-notes.js.map